import script from "./CategorySorter.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySorter.vue?vue&type=script&setup=true&lang=js"

import "./CategorySorter.vue?vue&type=style&index=0&id=a4d8aed0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4d8aed0"]])

export default __exports__